import { GeneralDetails } from './General/GeneralDetails'

export const hsDetailsRoute = {
  general: 'general'
}

export const hsDetailsRoutes = [
  {
    path: hsDetailsRoute.general,
    component: GeneralDetails
  }
]
